import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// This file is autogenerated. Any changes will be overwritten in next build.

const Info = props => {
  const {
    size,
    color
  } = props;
  const sizeMap = {
    sm: 20,
    md: 24,
    lg: 28
  };
  let sizeValue = size;
  if (typeof size === 'number') {
    sizeValue = size;
  } else if (typeof size === 'string') {
    sizeValue = sizeMap[size];
  }
  return /*#__PURE__*/_jsxs("svg", {
    width: sizeValue,
    height: sizeValue,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M11.0655 14.7015C11.0655 14.7567 11.1103 14.8015 11.1655 14.8015H12.3764C12.4316 14.8015 12.4764 14.7567 12.4764 14.7015V14.4241C12.4764 14.0838 12.5151 13.7978 12.59 13.5638L12.5902 13.5632C12.664 13.3273 12.8013 13.0959 13.006 12.8692L13.0068 12.8683C13.2134 12.634 13.5144 12.3612 13.9122 12.0495C14.3689 11.7066 14.7657 11.3827 15.1021 11.0778L15.1021 11.0778L15.1027 11.0772C15.4444 10.7618 15.7101 10.4161 15.8982 10.04L15.8985 10.0394C16.0889 9.65277 16.1819 9.19145 16.1819 8.65902C16.1819 7.69772 15.85 6.93396 15.1808 6.38028C14.5134 5.8225 13.5802 5.55039 12.3946 5.55039C11.6715 5.55039 11.0134 5.62675 10.4211 5.78051C9.83266 5.93328 9.28623 6.13155 8.78211 6.37557C8.73284 6.39942 8.7119 6.45846 8.73514 6.50803L9.2632 7.63417C9.28646 7.68377 9.3453 7.70542 9.39516 7.68273C9.82185 7.48857 10.2668 7.32207 10.7299 7.18326C11.1861 7.04654 11.7103 6.97737 12.3036 6.97737C13.0314 6.97737 13.5803 7.13174 13.9632 7.42717L13.9632 7.42717L13.9639 7.4277C14.3419 7.71408 14.5343 8.12779 14.5343 8.68423C14.5343 9.03763 14.4754 9.33323 14.3618 9.57446C14.2474 9.81735 14.0562 10.065 13.7835 10.3168C13.5135 10.566 13.1428 10.8721 12.6705 11.2354L12.6704 11.2355C12.26 11.5521 11.9353 11.8542 11.6983 12.1419L11.6983 12.1419L11.6975 12.1429C11.4651 12.4328 11.3008 12.7473 11.2059 13.0859C11.1116 13.4166 11.0655 13.8101 11.0655 14.2645V14.7015Z",
      fill: color,
      stroke: color,
      strokeWidth: "0.2",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "12",
      cy: "12",
      r: "10.1111",
      stroke: color,
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "11.8303",
      cy: "17.2553",
      r: "1.29995",
      fill: color
    })]
  });
};
export { Info };